import { ReactElement } from 'react';

import { BindingCreator } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';

import { StyledUrgentField } from './UrgentField.styled';

type UrgentFieldFormBeanPart = {
   urgent: boolean;
};

type UrgentFieldProps = {
   register: BindingCreator<UrgentFieldFormBeanPart>;
};

export const UrgentField = (props: UrgentFieldProps): ReactElement => {
   return (
      <StyledUrgentField
         testId={'urgent'}
         label={translationKeys.urgent.singular}
         controller={props.register('urgent')}
      />
   );
};
